import { useSelector } from "react-redux";
import { State } from "../../../reducer";
import { LayoutAdminCafe, LayoutUserCafe } from "../../../layout/layout_cafe";
import MenuListBar from "./menu.list.bar";

function MenuBar() {
  const user = useSelector((state: State) => state.user);
  return (
    <div>
      {user.role === "admin" ? (
        <LayoutAdminCafe>
          <MenuListBar />
        </LayoutAdminCafe>
      ) : (
        <LayoutUserCafe>
          <MenuListBar />
        </LayoutUserCafe>
      )}
    </div>
  );
}
export default MenuBar;
